// extracted by mini-css-extract-plugin
module.exports = {"sub-headings":"styles-module__sub-headings___XGCno"};